import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const FileMessageIcon = (props: IconProps) => (
  <Icon width="24px" height="24px" viewBox="0 0 24 24" {...props}>
    <path d="M19.25 13.727v3.637c0 1-.788 1.818-1.75 1.818s-1.75-.818-1.75-1.818v-4.091c0-.255.193-.455.438-.455s.437.2.437.455v4.09h1.75v-4.09c0-1.255-.98-2.273-2.188-2.273C14.98 11 14 12.018 14 13.273v4.09C14 19.374 15.566 21 17.5 21s3.5-1.627 3.5-3.636v-3.637h-1.75Z" />
    <path d="M10.5 17.6H6.4L3 21V5.7C3 4.765 3.765 4 4.7 4h13.6c.935 0 1.7.765 1.7 1.7v4.95h-1.7V5.7H4.7v10.2h5.8v1.7Z" />
  </Icon>
);

export default memo(FileMessageIcon);
